<div class="ds-websites-list" (mouseleave)="onClose.emit()">
  <div *ngIf="title" class="db-websites-list-title" [innerHTML]="title"></div>
  <ul dbCustomScrollbar>
    <li *ngFor="let website of websites">
      <a class="db-websites-list-item" [routerLink]="[website?.redirectionUrl]" (click)="onClose.emit()">
        <img *ngIf="website?.screenshot" [src]="website?.screenshot" alt=""/>
        <div>
          <p [innerHTML]="website?.title"></p>
          <a [innerHTML]="website?.link"></a>
        </div>
        <i class="db-icon db-icon-ds-arrow-oblique"></i>
      </a>
    </li>
  </ul>
</div>
